import React from "react";
import { Outlet } from "react-router-dom";


const AdminQuizzes = () => {

  return (
    <div className="mx-auto max-w-full px-5 lg:px-20">
      <div className="px-3 py-20 bg-opacity-10">
        <Outlet/>
      </div>
    </div>
  );
};

export default AdminQuizzes;
